module.exports = __webpack_public_path__ + "static/media/18.61c28983.png";